<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="600px" scrollable :fullscreen="$vuetify.breakpoint.name == `xs`">
            <v-card :loading="loading" outlined>
                <v-card-title class="primary" dense>
                    <span class="headline text-uppercase white--text">{{ title }}</span>
                </v-card-title>
                <v-card-text>
                    <v-form  ref="form" v-model="valid" :lazy-validation="lazy">
                        <v-row>
                            <v-col cols="5">
                                <v-select
                                    v-model="role.product_id"
                                    :items="products"
                                    item-text="name"
                                    item-value="id"
                                    :rules="[required]"
                                    label="Produto"
                                    placeholder="Selecione o produto"
                                    outlined
                                ></v-select>
                            </v-col>
                            <v-col cols="7">
                                <v-text-field v-model="role.name" :rules="[required]" label="Nome" placeholder="Insira o nome da função" outlined></v-text-field>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="close" outlined>
                        <v-icon left>mdi-close-circle-outline</v-icon>FECHAR
                    </v-btn>
                    <v-btn color="primary" @click="save" :disabled="!canSave">
                        <v-icon left>mdi-content-save-outline</v-icon>SALVAR
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
    import { required } from '@/utils/roles.js'
    import { mapState, mapGetters } from 'vuex'
    export default {
        data: () => ({
            loading: null,
            valid: null,
            lazy: false
        }),
        computed: {
            ...mapState('product', ['products']),
            ...mapGetters('app', ['hasRole']),
            title() {
                if (this.role.id) {
                    return 'Função: '+ this.role.name
                }
                return 'Nova Função'                
            },
            dialog: {
                get() { return this.value },
                set(v) { this.$emit('input', v) }
            },
            canSave() {
                if (this.role.id) {
                    return this.hasRole(['ADMIN', 'role:update'])
                }
                return this.hasRole(['ADMIN', 'role:create'])
            }
        },
        methods: {
            required,
            save() {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    if (this.role.id) {
                        this.update(this.role)
                    }
                    else {
                        this.insert(this.role)
                    }
                }
            },
            insert(item) {
                var context = this
                this.axios.post(this.$store.state.url_api + '/role/', item)
                    .then(r => {
                        context.loading = false
                        context.$emit('save', { item: r.data, isNew: true })
                    })
                    .catch(() => {
                        context.loading = false
                    })
            },
            update(item) {
                var context = this
                delete item.loading
                delete item.loading_remove
                this.axios.put(this.$store.state.url_api + '/role/' + item.id, item)
                    .then(() => {
                        context.loading = false
                        context.$emit('save', { item: context.role })
                        context.dialog = false
                    })
                    .catch(() => {
                        context.loading = false
                    })
            },
            close() {
                this.dialog = false
                this.$emit('clear')
                this.$refs.form.reset()
            }
        },
        props: {
            value: Boolean,
            role: {},
            index: Number
        }   
    }
</script>